var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArchiveWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 19.25,
    viewBox: "0 0 22 19.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4598",
    "data-name": "Path 4598",
    d: "M8.938-17.875H-8.937A2.062,2.062,0,0,0-11-15.812v2.75a1.372,1.372,0,0,0,1.336,1.375l.039,10.313a2.75,2.75,0,0,0,2.75,2.75H6.875a2.75,2.75,0,0,0,2.75-2.75V-11.687A1.372,1.372,0,0,0,11-13.024v-2.789A2.063,2.063,0,0,0,8.938-17.875ZM6.875-.687H-6.875a.687.687,0,0,1-.688-.687V-11.687H7.563V-1.375A.69.69,0,0,1,6.875-.687ZM8.938-13.75H-8.938v-2.062H8.938ZM-3.132-7.562H3.055a1.038,1.038,0,0,0,1.07-1.031A1.029,1.029,0,0,0,3.094-9.625H-3.132a1.013,1.013,0,0,0-.993.993A1.031,1.031,0,0,0-3.132-7.562Z",
    transform: "translate(11 17.875)",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveWhite);
export default __webpack_public_path__ + "static/media/archive-white.4db92542edf6dbc906c511f47b04bd26.svg";
export { ForwardRef as ReactComponent };